<template>
  <div>
    <div id="monitoramento">
      <div class="row">
        <div class="col-md-12 text-center">
          <vuestic-widget>
            <div class="row cabecalho">
              <div class="col-12">
                <ul class="nav nav-fill">
                  <li class="nav-item">
                    <strong> Sala </strong>
                    <br />
                    <span>{{ aula.sala.sala }}</span>
                  </li>
                  <li class="nav-item">
                    <strong> Quantidade de Alunos </strong>
                    <br />
                    <span>{{ alunos.length }}</span>
                  </li>
                  <li class="nav-item">
                    <strong> Horario </strong>
                    <br />
                    <span> {{ horario(aula.inicio,aula.fim)  }} </span>
                  </li>
                  <li class="nav-item">
                    <strong> Materia </strong>
                    <br />
                    <span>{{ aula.materia.titulo }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12" style="margin-bottom: 20px">
                <button
                  @click="minimizar()"
                  class="btn btn-sm btn-info"
                  title="Minimizar Informações"
                >
                  <span
                    aria-hidden="true"
                    class="fa fa-eye-slash"
                    style="font-size: 16px; padding-left: 3px"
                  ></span>
                </button>
                <button @click="maximizar()" class="btn btn-sm btn-success">
                  <span
                    aria-hidden="true"
                    class="fa fa-eye"
                    style="font-size: 16px; padding-left: 3px"
                    title="Mostrar Informações"
                  ></span>
                </button>
              </div>
            </div>
            <div class="row text-center">
              <!-- Card Instrutor -->
              <div class="col-sm-3">
                <div
                  class="card"
                  @click="openModalInstrutor()"
                  v-if="instrutor !== []"
                >
                  <div class="col-sm-12">
                    <img
                      v-if="instrutor.fotos"
                      width="250px"
                      height="200px"
                      :src="
                        'data:image/' +
                        instrutor.fotos[0].ext +
                        ';base64, ' +
                        instrutor.fotos[0].foto
                      "
                      alt="Imagem"
                    />
                    &nbsp;
                  </div>
                  <div class="container">
                    <br />
                    <h6>
                      <b>{{ instrutor.nome }}</b>
                    </h6>
                    <h6>{{ instrutor.cnh }}</h6>
                    <h6>Instrutor</h6>

                    <div class="row" style="justify-content: center">
                      <div class="col-sm-10">
                        <table class="table-responsive-sm">
                          <tr>
                            <td>Fotos tiradas:</td>
                            <td v-if="instrutor.fotos">{{ instrutor.fotos.length }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <br />
                    <br />
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <p style="color: red">CLASSIFICAR TODAS AS FOTOS</p>
                      <button
                        title="Nenhum aluno detectado"
                        class="btn btn-danger btn-with-icon rounded-icon size"
                        @click="imageStatusTodosInstrutor(2)"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-user-times"
                          style="font-size: 16px; padding-left: 6px"
                        ></span>
                      </button>
                      &nbsp;
                      <button
                        title="Sem imagem"
                        class="btn btn-danger btn-with-icon rounded-icon size"
                        @click="imageStatusTodosInstrutor(1)"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-low-vision"
                          style="font-size: 16px; padding-left: 2px"
                        ></span>
                      </button>
                      &nbsp;
                      <button
                        title="Imagem com erro"
                        class="btn btn-warning btn-with-icon rounded-icon size"
                        @click="imageStatusTodosInstrutor(3)"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-exclamation-triangle"
                          style="font-size: 16px; padding-left: 3px"
                        ></span>
                      </button>
                      &nbsp;
                      <button
                        title="Imagem OK"
                        class="btn btn-success btn-with-icon rounded-icon size"
                        @click="imageStatusTodosInstrutor(4)"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-check"
                          style="font-size: 16px; padding-left: 3px"
                        ></span>
                      </button>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <!-- Fim do card instrutor -->
              <!-- Card do Aluno -->
              <div
                class="col-sm-3"
                v-for="(aluno, index) in alunos"
                :key="'aluno_' + aluno.id_aluno"
                :id="'aluno_' + aluno.id_aluno"
              >
                <div class="card">
                  <div class="col-md-12" @click="openModal(aluno)">
                    <img
                      v-if="aluno.fotos"
                      class="avatar"
                      width="250"
                      height="200px"
                      :src="
                        'data:image/' +
                        aluno.fotos[0].ext +
                        ';base64, ' +
                        aluno.fotos[0].foto
                      "
                      alt="Imagem"
                    />
                    &nbsp;
                  </div>

                  <div class="container">
                    <br />
                    <h6>
                      <b>{{ aluno.nome }}</b>
                    </h6>
                    <h6>{{ aluno.cpf }}</h6>
                    <h6>Aluno</h6>

                    <div class="row" style="justify-content: center">
                      <div class="col-sm-10">
                        <table class="table-responsive-sm">
                          <tr>
                            <td>Fotos tiradas:</td>
                            <td v-if="aluno.fotos ">{{ aluno.fotos.length }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <br />
                    <br />
                  </div>
                  <div class="row" v-if="aviso">
                    <div class="col-md-12">
                      <p style="color: red">CLASSIFICAR TODAS AS FOTOS</p>
                      <button
                        title="Nenhum aluno detectado"
                        class="btn btn-danger btn-with-icon rounded-icon size"
                        @click="imageStatusTodos(index, 2)"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-user-times"
                          style="font-size: 16px; padding-left: 6px"
                        ></span>
                      </button>
                      &nbsp;
                      <button
                        title="Sem imagem"
                        class="btn btn-danger btn-with-icon rounded-icon size"
                        @click="imageStatusTodos(index, 1)"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-low-vision"
                          style="font-size: 16px; padding-left: 2px"
                        ></span>
                      </button>
                      &nbsp;
                      <button
                        title="Imagem com erro"
                        class="btn btn-warning btn-with-icon rounded-icon size"
                        @click="imageStatusTodos(index, 3)"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-exclamation-triangle"
                          style="font-size: 16px; padding-left: 3px"
                        ></span>
                      </button>
                      &nbsp;
                      <button
                        title="Imagem OK"
                        class="btn btn-success btn-with-icon rounded-icon size"
                        @click="imageStatusTodos(index, 4)"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-check"
                          style="font-size: 16px; padding-left: 3px"
                        ></span>
                      </button>
                    </div>
                  </div>
                  <div class="row" v-else>
                    <div class="col-md-12">
                      <p style="color: red">CLASSIFICAR TODAS AS FOTOS</p>
                      <button
                        title="Nenhum aluno detectado"
                        class="btn btn-danger btn-with-icon rounded-icon size"
                        @click="avisar()"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-user-times"
                          style="font-size: 16px; padding-left: 6px"
                        ></span>
                      </button>
                      &nbsp;
                      <button
                        title="Sem imagem"
                        class="btn btn-danger btn-with-icon rounded-icon size"
                        @click="avisar()"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-low-vision"
                          style="font-size: 16px; padding-left: 2px"
                        ></span>
                      </button>
                      &nbsp;
                      <button
                        title="Imagem com erro"
                        class="btn btn-warning btn-with-icon rounded-icon size"
                        @click="avisar()"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-exclamation-triangle"
                          style="font-size: 16px; padding-left: 3px"
                        ></span>
                      </button>
                      &nbsp;
                      <button
                        title="Imagem OK"
                        class="btn btn-success btn-with-icon rounded-icon size"
                        @click="avisar()"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-check"
                          style="font-size: 16px; padding-left: 3px"
                        ></span>
                      </button>
                    </div>
                  </div>
                  <br />
                </div>
              </div>

              <!-- Fim card aluno -->
              <!-- MODAL DO ALUNO -->
              <vuestic-modal
                id="modal-user"
                ref="smallModal"
                :cancelClass="'none'"
                :okClass="'none'"
                :closeIconShown="true"
                :large="true"
              >
                <div v-if="alunoModalCheck" class="row text-center">
                  <div class="col-sm-12">
                    <h3>
                      {{ alunoModal.nome }} -
                      {{ alunoModal.cpf }}
                    </h3>
                  </div>
                </div>
                <div class="row" v-if="alunoModal != 0">
                  <div
                    class="col-sm-3"
                    v-for="(foto, index) in alunoModal.fotos"
                    :key="'foto_' + foto.id_foto_teorica + '_' + index"
                  >
                    <div class="card">
                      <div class="row">
                        <div class="col-sm-12">
                          <img
                            v-if="foto.id_status === 1"
                            class="avatar"
                            width="300px"
                            height="300px"
                            :src="
                              'data:image/' + foto.ext + ';base64, ' + foto.foto
                            "
                            alt="Imagem"
                            :id="
                              'foto_' +
                              foto.id_foto_teorica +
                              '_' +
                              alunoModal +
                              '_1'
                            "
                            style="border: solid 5px rgb(255, 0, 0)"
                          />

                          <img
                            v-else-if="foto.id_status === 2"
                            class="avatar"
                            width="300px"
                            height="300px"
                            :src="
                              'data:image/' + foto.ext + ';base64, ' + foto.foto
                            "
                            alt="Imagem"
                            :id="
                              'foto_' +
                              foto.id_foto_teorica +
                              '_' +
                              alunoModal +
                              '_2'
                            "
                            style="border: solid 5px rgb(255, 0, 0)"
                          />

                          <img
                            v-else-if="foto.id_status === 3"
                            class="avatar"
                            width="300px"
                            height="300px"
                            :src="
                              'data:image/' + foto.ext + ';base64, ' + foto.foto
                            "
                            alt="Imagem"
                            :id="
                              'foto_' +
                              foto.id_foto_teorica +
                              '_' +
                              alunoModal +
                              '_3'
                            "
                            style="border: solid 5px rgb(255, 251, 0)"
                          />

                          <img
                            v-else-if="foto.id_status === 4"
                            class="avatar"
                            width="300px"
                            height="300px"
                            :src="
                              'data:image/' + foto.ext + ';base64, ' + foto.foto
                            "
                            alt="Imagem"
                            :id="
                              'foto_' +
                              foto.id_foto_teorica +
                              '_' +
                              alunoModal +
                              '_5'
                            "
                            style="
                              border: solid 5px rgb(9, 255, 0);
                              border-radius: 2%;
                            "
                          />

                          <img
                            v-else
                            class="avatar"
                            width="300px"
                            height="300px"
                            :src="
                              'data:image/' + foto.ext + ';base64, ' + foto.foto
                            "
                            alt="Imagem"
                            :id="
                              'foto_' + foto.id_foto_teorica + '_' + alunoModal
                            "
                          />
                          &nbsp;
                        </div>
                      </div>
                      <br />
                      <div class="col-sm-12">
                        <h4>
                          {{ alunoModal.fotos.length - index }}º foto
                        </h4>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <button
                            title="Remover foto do aluno"
                            class="btn btn-danger btn-with-icon rounded-icon size"
                            @click="imageRemove(alunoModal, index)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-file-image-o"
                              style="font-size: 16px; padding-left: 6px"
                            ></span>
                          </button>
                          &nbsp;

                          <button
                            title="Nenhum aluno detectado"
                            class="btn btn-danger btn-with-icon rounded-icon size"
                            @click="imageStatus(alunoModal, index, 2, true)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-user-times"
                              style="font-size: 16px; padding-left: 6px"
                            ></span>
                          </button>
                          &nbsp;
                          <button
                            title="Sem imagem"
                            class="btn btn-danger btn-with-icon rounded-icon size"
                            @click="imageStatus(alunoModal, index, 1, true)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-low-vision"
                              style="font-size: 16px; padding-left: 2px"
                            ></span>
                          </button>
                          &nbsp;
                          <button
                            title="Imagem com erro"
                            class="btn btn-warning btn-with-icon rounded-icon size"
                            @click="imageStatus(alunoModal, index, 3, true)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-exclamation-triangle"
                              style="font-size: 16px; padding-left: 3px"
                            ></span>
                          </button>
                          &nbsp;
                          <button
                            title="Imagem OK"
                            class="btn btn-success btn-with-icon rounded-icon size"
                            @click="imageStatus(alunoModal, index, 4, true)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-check"
                              style="font-size: 16px; padding-left: 3px"
                            ></span>
                          </button>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                </div>
              </vuestic-modal>
              <!-- FIM DO MODAL DO ALUNO -->

              <!-- MODAL DO INSTRUTOR -->
              <vuestic-modal
                id="modal-user-instrutor"
                ref="smallModalInstrutor"
                :cancelClass="'none'"
                :okClass="'none'"
                :closeIconShown="true"
                :large="true"
              >
                <h3>{{ instrutor.nome }} - {{ instrutor.cnh }}</h3>
                <div class="row" v-if="instrutor != []">
                  <div
                    class="col-sm-3"
                    v-for="(foto, index) in instrutor.fotos"
                    :key="foto.id_foto_teorica"
                  >
                    <div class="card">
                      <div class="row">
                        <div class="col-sm-12">
                          <img
                            v-if="foto.id_status === 1"
                            class="avatar"
                            width="300px"
                            height="300px"
                            :src="
                              'data:image/' + foto.ext + ';base64, ' + foto.foto
                            "
                            alt="Imagem"
                            :id="
                              'foto_' +
                              foto.id_foto_teorica +
                              '_' +
                              instrutor.nome +
                              '_1'
                            "
                            style="border: solid 5px rgb(255, 0, 0)"
                          />

                          <img
                            v-else-if="foto.id_status === 2"
                            class="avatar"
                            width="300px"
                            height="300px"
                            :src="
                              'data:image/' + foto.ext + ';base64, ' + foto.foto
                            "
                            alt="Imagem"
                            :id="
                              'foto_' +
                              foto.id_foto_teorica +
                              '_' +
                              instrutor +
                              '_2'
                            "
                            style="border: solid 5px rgb(255, 0, 0)"
                          />

                          <img
                            v-else-if="foto.id_status === 3"
                            class="avatar"
                            width="300px"
                            height="300px"
                            :src="
                              'data:image/' + foto.ext + ';base64, ' + foto.foto
                            "
                            alt="Imagem"
                            :id="
                              'foto_' +
                              foto.id_foto_teorica +
                              '_' +
                              instrutor +
                              '_3'
                            "
                            style="border: solid 5px rgb(255, 251, 0)"
                          />

                          <img
                            v-else-if="foto.id_status === 4"
                            class="avatar"
                            width="300px"
                            height="300px"
                            :src="
                              'data:image/' + foto.ext + ';base64, ' + foto.foto
                            "
                            alt="Imagem"
                            :id="
                              'foto_' +
                              foto.id_foto_teorica +
                              '_' +
                              instrutor +
                              '_5'
                            "
                            style="border: solid 5px rgb(9, 255, 0)"
                          />

                          <img
                            v-else
                            class="avatar"
                            width="300px"
                            height="300px"
                            :src="
                              'data:image/' + foto.ext + ';base64, ' + foto.foto
                            "
                            alt="Imagem"
                            :id="
                              'foto_' + foto.id_foto_teorica + '_' + instrutor
                            "
                          />
                          &nbsp;
                        </div>
                      </div>
                      <br />
                      <div class="col-sm-12">
                        <h4 v-if="instrutor.fotos">{{ instrutor.fotos.length - index }}º foto</h4>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <button
                            title="Nenhum aluno detectado"
                            class="btn btn-danger btn-with-icon rounded-icon size"
                            @click="imageStatusInstrutor(index, 2)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-user-times"
                              style="font-size: 16px; padding-left: 6px"
                            ></span>
                          </button>
                          &nbsp;
                          <button
                            title="Sem imagem"
                            class="btn btn-danger btn-with-icon rounded-icon size"
                            @click="imageStatusInstrutor(index, 1)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-low-vision"
                              style="font-size: 16px; padding-left: 2px"
                            ></span>
                          </button>
                          &nbsp;
                          <button
                            title="Imagem com erro"
                            class="btn btn-warning btn-with-icon rounded-icon size"
                            @click="imageStatusInstrutor(index, 3)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-exclamation-triangle"
                              style="font-size: 16px; padding-left: 3px"
                            ></span>
                          </button>
                          &nbsp;
                          <button
                            title="Imagem OK"
                            class="btn btn-success btn-with-icon rounded-icon size"
                            @click="imageStatusInstrutor(index, 4)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-check"
                              style="font-size: 16px; padding-left: 3px"
                            ></span>
                          </button>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                </div>
              </vuestic-modal>
              <!-- FIM DO MODAL DO ALUNO -->
            </div>
            <vuestic-modal
              id="modal-user-info"
              ref="avisar"
              :cancelClass="'none'"
              :okClass="'none'"
              :closeIconShown="true"
              :large="false"
            >
              <div class="row text-center">
                <div class="col-sm-12">
                  <h3>Aviso</h3>
                  <p>
                    Para classificar as fotos individulamente click primeiro no
                    card.
                  </p>
                </div>
              </div>
            </vuestic-modal>
          </vuestic-widget>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MonitoramentoController from './MonitoramentoController'
import urlApi from '../../router/urlApi'

export default {
  data () {
    return {
      sala: this.$route.params['idSala'],
      aula: [],
      instrutor: [],
      alunos: [],
      entidades: [],
      alunoModal: 0,
      alunoModalCheck: false,
      aviso: false,
      ultimo: 0,
      timeout: null,
    }
  },
  mounted () {
    this.atualizar()
  },
  beforeDestroy () {
    clearTimeout(this.timeout)
    console.log('fechou a tela ' + this.timeout)
  },

  methods: {
    atualizar () {
      let self = this

      this.$http
        .get(
          urlApi +
            '/aulas/teoricas/cfc/' +
            this.sala.cfc +
            '/sala/' +
            this.sala.id
        )
        .then((response) => {
          this.aula = response.body.dados.aula
          this.alunos = response.body.dados.alunos
          this.instrutor = this.aula.instrutor
        })
        .catch((response) => {})

      this.alunos.sort(function (a, b) {
        console.log(a)
        if (a.id_aluno > b.id_aluno) {
          return 1
        }

        if (a.id_aluno < b.id_aluno) {
          return -1
        }

        return 0
      })

      console.log(this.alunos)

      this.timeout = setTimeout(function () {
        self.atualizar()
      }, 60000)
    },

    avisar () {
      let self = this
      self.$refs.avisar.open()
      this.aviso = true
    },

    maximizar () {
      let el = document.getElementsByClassName('container')

      for (let index = 0; index < el.length; index++) {
        el[index].style.display = 'block'
      }
    },

    minimizar () {
      let el = document.getElementsByClassName('container')

      for (let index = 0; index < el.length; index++) {
        el[index].style.display = 'none'
      }
    },

    openModal (aluno) {
      let self = this
      self.alunoModal = aluno
      self.alunoModalCheck = true
      self.$refs.smallModal.open()
    },

    openModalInstrutor (idInstrutor) {
      let self = this
      self.InstrutorModalCheck = true
      self.$refs.smallModalInstrutor.open()
    },

    mostrar (elemento, event) {
      let el = document.getElementById(elemento)
      if (el.style.display === 'block') el.style.display = 'none'
      else el.style.display = 'block'
    },

    imageRemove(aluno, key) {
      const id_aula_teorica = this.sala.aula.aula.id_aula_teorica;
      const id_turma_teorica = this.sala.aula.aula.id_turma_teorica;
      const cfc = this.sala.cfc;
      const idFoto = aluno.fotos[key].id_foto_teorica;
      const instanciaVue = this;

      MonitoramentoController.removeFoto(instanciaVue, cfc, id_turma_teorica, id_aula_teorica, idFoto);
    },

    imageStatus (aluno, key, type, canvas = true) {
      let idFoto = this.alunos[aluno].fotos[key].id_foto_teorica

      MonitoramentoController.updateFoto(idFoto, type)

      this.alunos[aluno].fotos[key].id_status = type
    },

    imageStatusInstrutor (key, type) {
      let idFoto = this.instrutor.fotos[key].id_foto_teorica

      MonitoramentoController.updateFoto(idFoto, type)

      this.instrutor.fotos[key].id_status = type
    },

    imageStatusTodosInstrutor (type) {
      let idInstrutor = this.instrutor.id_instrutor

      MonitoramentoController.updateFotoEntidadeInstrutor(
        idInstrutor,
        type,
        this.aula.id_aula_teorica
      )

      this.instrutor.fotos.forEach((foto) => {
        foto.id_status = type
      })
    },

    imageStatusTodos (aluno, type) {
      let idAluno = this.alunos[aluno].id_aluno

      MonitoramentoController.updateFotoEntidade(
        idAluno,
        type,
        this.aula.id_aula_teorica
      )

      this.alunos[aluno].fotos.forEach((foto) => {
        foto.id_status = type
      })
    },
    horario(inicio, fim) {
        var ini = inicio.split(' ')[1];
        var end = fim.split(' ')[1];

        return `De ${ini} ate ${end}`;
    },
  },
}
</script>

<style scoped>
.aula {
  border: rgb(134, 129, 129) solid 2px;
  border-radius: 2%;
}

/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgb(24, 255, 3);
}

/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}

.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 10px;
  /* 5px rounded corners */
  margin: 5px;
}

/* Add rounded corners to the top left and the top right corner of the image */
.img-monit {
  width: 450px;
  border-radius: 10px 10px 0 0;
}

.img-monit-modal {
  width: 500px;
  height: 500px;
  border-radius: 10px;
}

.img-thumb {
  width: 300px;
  height: 300px;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

#clock {
  font-family: "Share Tech Mono", monospace;
  color: #080808;
  text-align: center;
}

.size {
  width: 4rem;
  height: 4rem;
}

tr {
  position: relative;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

table {
  width: 100%;
}

.dados {
  background-color: #ffffff;
}

.cabecalho{
    border-bottom: 2px solid #eeeeee;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: rgb(238, 238, 238);

    height: 55px;
    padding: 0 1.5625rem;
    border-bottom: 2px solid #eeeeee;
    font-size: 10pt;
    font-weight: 600;
}
</style>
